"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:OverlayBarcodeView");

var EAN13_STRUCTURE = [
    'LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG',
    'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'
];

var BINARIES = {
    'L': [ // The L (left) type of encoding
        '0001101', '0011001', '0010011', '0111101', '0100011',
        '0110001', '0101111', '0111011', '0110111', '0001011'
    ],
    'G': [ // The G type of encoding
        '0100111', '0110011', '0011011', '0100001', '0011101',
        '0111001', '0000101', '0010001', '0001001', '0010111'
    ],
    'R': [ // The R (right) type of encoding
        '1110010', '1100110', '1101100', '1000010', '1011100',
        '1001110', '1010000', '1000100', '1001000', '1110100'
    ]
};

var SIDE_BIN = '101';
var MIDDLE_BIN = '01010';



/**
 * Affiche un code barre
 * Trigger:
 */
module.exports = Backbone.View.extend({

    pageModel: null,
    documentModel: null,
    barcode: null,
    placement: "midlast",
    height: 10, // hauteur du code barre en mm
    //className: "overlay", // pas de class pour que l'élément ne soit pas facilement sélectionnable dans puppeteer

    initialize: function (options) {
        var T = this;
        _.extend(T, options);
        T.listenTo(T.pageModel, "sync", T.render);
        T.render();
    },

    checksum: function (number) {
        var res = number
            .substr(0, 12)
            .split('')
            .map(function(n){return +n;})
            .reduce(function(sum, a, idx) {return idx % 2 ? sum + a * 3 : sum + a;}, 0);

        return (10 - (res % 10)) % 10;
    },

    encode: function (data, structure) {
        var encoded = data
            .split('')
            .map(function(val, idx) { return BINARIES[structure[idx]];})
            .map(function(val, idx) { return val ? val[data[idx]] : '';});
        return encoded.join('');
    },

    generate: function (ean, options) {
        // from https://github.com/lindell/JsBarcode/tree/master/src/barcodes/EAN_UPC
        if (!ean || ean.length != 12 || ean.search(/^[0-9]{12}$/) !== 0) throw new Error('Invalid EAN 13, should have 12 digits');

        ean += this.checksum(ean);

        var ean_code = SIDE_BIN;

        const left_str = ean.substr(1, 6);
        const structure = EAN13_STRUCTURE[ean[0]];
        ean_code += this.encode(left_str, structure);

        ean_code += MIDDLE_BIN;

        const right_str = ean.substr(7, 6);
        ean_code += this.encode(right_str, 'RRRRRR');

        ean_code += SIDE_BIN;

        //console.log(ean_code);

        var height = options.height || 100;
        var bar_width = options.barWidth || 1;
        var width = 95 * bar_width;
        var svg_str = '<svg width="100%" preserveAspectRatio="none" viewBox="0 0 ' + width + ' ' + height + '" xmlns="http://www.w3.org/2000/svg" version="1.1">';
        
        // bars
        var bar_pos = 0;

        function addBar(start, end) {
            var line = '<rect x="' + start + '" y="0" width="' + (end - start) + '" height="' + height + '"/>';
            svg_str += line;
        }


        var black_bar_start = -1;
        for (var i = 0; i < ean_code.length; i++) {
            // lines
            if (ean_code[i] == "1") {
                if (black_bar_start == -1) {
                    black_bar_start = bar_pos; // nouvelle barre
                }
            } else {
                if (black_bar_start != -1) {
                    addBar(black_bar_start, bar_pos);
                    black_bar_start = -1;
                }
            }
            bar_pos += bar_width;
        }

        if (black_bar_start!=-1) {
            addBar(black_bar_start, bar_pos);
        }

        // end
        svg_str += '</svg >';
        return svg_str;
    },

    render: function () {
        var T = this;

        T.$el.html("");

        if (T.pageModel.fetched) {
            debug("render barcode " + T.page);
            var page_width = T.pageModel.get("width");
            var page_height = T.pageModel.get("height");

            var barcode_width, barcode_height, barcode_left;
            var align = null;

            var $div = $("<div/>");

            if (T.placement == "midlast") {

                // algo plcement à la fin et au milieu
                var nb_pages = T.documentModel.get("nbPages");
                var middle_page = nb_pages / 2;
                var last_page = nb_pages;
                var page_to_tag;

                if (T.pageModel.get("number").indexOf(last_page) != -1) {
                    page_to_tag = last_page;
                } else if (T.pageModel.get("number").indexOf(middle_page) != -1) {
                    page_to_tag = middle_page;
                }

                if (page_to_tag) {
                    align = T.pageModel.get("isDouble") ? (page_to_tag % 2 ? "right" : "left") : "center";

                    barcode_height = Math.round(T.height * (T.pageModel.get("dpi") / 25.4)); // pixel
                    barcode_width = barcode_height * 10;
                }
                else {
                    // pas de page à taguer avec le code barre
                    return;
                }
            }
            else {
                throw new Error("unsupported barcode placement");
            }

            if (align == "center") {
                barcode_left = Math.round(page_width / 2 - barcode_width / 2);
            }
            else if (align == "left") {
                barcode_left = Math.round(page_width / 4 - barcode_width / 2);
            }
            else if (align == "right") {
                barcode_left = Math.round(page_width / 4 * 3 - barcode_width / 2);
            }

            $div.css({
                "position": "absolute",
                "display": "block",
                "z-index": 40,
                "background-color": "white",
                bottom: 0,
                left: (barcode_left / page_width * 100) + "%",
                height: ((barcode_height / page_height) * 100) + "%",
                width: ((barcode_width / page_width) * 100) + "%"
            });

            var $svg = $(this.generate(T.barcode, { height: 100, barWidth: 4 }));
            $div.append($svg);
            T.$el.append($div);
        }
    },

    close: function () {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/reader/views/overlay-barcode-view.js
// module id = 49
// module chunks = 0